import { Paper, Tab, Tabs, withStyles } from "@material-ui/core";

export const StyledPaperTabs = withStyles((theme) => ({
  root: {
    boxShadow: "none",
    borderBottom: "1px solid #EEEEEE",
  },
}))(Paper);

export const StyledPaperTabsB = withStyles((theme) => ({
  root: {
    boxShadow: "none",
    border: "none",
  },
}))(Paper);

export const StyledTabs = withStyles((theme) => ({
  indicator: {
    backgroundColor: "#2196F3 !important",
  },
}))(Tabs);

export const StyledTabsB = withStyles((theme) => ({
  indicator: {
    backgroundColor: "#212121 !important",
  },
}))(Tabs);

export const StyledTab = withStyles((theme) => ({
  root: {
    fontSize: 13,
    fontWeight: "bold",
    textTransform: "capitalize",
    "&:hover": {
      borderBottom: "2px solid #2196F3 !important",
      color: "#2196F3 !important",
    },
    "&:selected": {
      borderBottom: "2px solid #2196F3 !important",
      color: "#2196F3 !important",
    },
    "&:focus": {
      borderBottom: "2px solid #2196F3 !important",
      color: "#2196F3 !important",
    },
    "&:active": {
      borderBottom: "2px solid #2196F3 !important",
      color: "#2196F3 !important",
    },
  },
  selected: {
    borderBottom: "2px solid #2196F3 !important",
    color: "#2196F3 !important",
  },
}))(Tab);

export const StyledTabB = withStyles((theme) => ({
  root: {
    fontSize: 13,
    fontWeight: "bold",
    textTransform: "capitalize",
    "&:hover": {
      boxShadow: "none !important",
      outline: "none !important",
      borderBottom: "2px solid #212121 !important",
      color: "#212121 !important",
    },
    "&:selected": {
      boxShadow: "none !important",
      outline: "none !important",
      borderBottom: "2px solid #212121 !important",
      color: "#212121 !important",
    },
    "&:focus": {
      boxShadow: "none !important",
      outline: "none !important",
      borderBottom: "2px solid #212121 !important",
      color: "#212121 !important",
    },
    "&:active": {
      boxShadow: "none !important",
      outline: "none !important",
      borderBottom: "2px solid #212121 !important",
      color: "#212121 !important",
    },
  },
  selected: {
    boxShadow: "none !important",
    outline: "none !important",
    borderBottom: "2px solid #212121 !important",
    color: "#212121 !important",
  },
}))(Tab);
